import clientCookies from 'client/cookies';

export default function getNumSubscriber(): string | undefined {
  const numSubscriber = clientCookies.get('numSubscriber');
  if (!numSubscriber) {
    return undefined;
  }
  return numSubscriber;
}
